import Global from '../constant.js'
import { reactive } from "vue"
import loadImage from 'blueimp-load-image'

export default function () {

  const imgStates = reactive({
    fileName: null,
    img: null,
    resizedImg: null,
    accountImageDisplay: null
  })

  // --- methods ---
  const attachImg = (mode, e) => {
    console.log(mode)
    const file = e.target.files[0];
    if (!file) {
      return
    }
    imgStates.fileName = file.name
    // プレビュー画像作成
    _preview(file, Global.display_image_max_size)

    const reader = new FileReader()
    reader.onload = (event) => {
      const image = new Image()
      image.crossOrigin = 'Anonymous'
      image.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const drawImageArgs = _drawImageArgs(image)
        canvas.width = drawImageArgs[7]
        canvas.height = drawImageArgs[8]
        ctx.drawImage(...drawImageArgs)
        const base64 = canvas.toDataURL()
        imgStates.img = _base64ToBlob(base64.replace(/^.*,/, ''))
      }
      image.src = event.target.result
    }
    reader.readAsDataURL(file)
  }
  const _preview = (file, maxSize) => {
    loadImage.parseMetaData(file, (data) => {
      const options = {
        maxHeight: maxSize,
        maxWidth: maxSize,
        canvas: true
      }
      if (data.exif) {
        options.orientation = data.exif.get('Orientation');
      }

      loadImage(
        file,
        async (canvas) => {
          const data = canvas.toDataURL(file.type)
          // data_url形式をblob objectに変換
          const blob = _base64ToBlob(data, file.type)
          // objectのURLを生成
          const url = window.URL.createObjectURL(blob)
          imgStates.resizedImg = url;
          imgStates.accountImageDisplay = false
        },
        options
      )
    })
  }
  const _drawImageArgs = (image) => {
    const maxSize = Global.updaload_account_image_max_size
    let sx = 0
    let sy = 0
    let dx = 0
    let dy = 0
    let imageWidth = image.width
    let imageHeight = image.height
    if (imageWidth > imageHeight) {
      sx = (imageWidth - imageHeight) / 2
      imageWidth = imageHeight
    }
    if (imageHeight > imageWidth) {
      sy = (imageHeight - imageWidth) / 6
      imageHeight = imageWidth
    }
    const dstWidth = imageWidth > maxSize ? imageWidth * maxSize / imageWidth : imageWidth
    const dstHeight = imageHeight > maxSize ? imageHeight * maxSize / imageHeight: imageHeight
    return [image, sx, sy, imageWidth, imageHeight, dx, dy, dstWidth, dstHeight]
  }
  const _base64ToBlob = (base64, fileType) => {
    const bin = atob(base64.replace(/^.*,/, ''));
    const buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    return new Blob([buffer.buffer], {
      type: fileType ? fileType : 'image/png'
    });
  }
  return {
    imgStates,
    attachImg
  }
}

